export * from '@lexical/react/LexicalPlainTextPlugin'
